import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue';
import { onClickOutside } from '@vueuse/core';
import { useMediaAsset } from '~/composables';

interface Props {
  value?: boolean;
  image?: string;
}
interface Emits {
  (e: 'input', data: Props['value']): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'UiPopup',
  props: {
    value: { type: Boolean, default: false },
    image: { default: undefined }
  },
  emits: ["input"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'input', data: Props['value']): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { value: boolean, image: string };





const { getAssetUrl } = useMediaAsset();

const popup = ref(null);
const localValue = computed({
  get() {
    return props.value;
  },
  set(newValue) {
    emit('input', newValue);
  },
});

const closePopup = () => (localValue.value = false);

onClickOutside(popup as any, () => closePopup());

return { __sfc: true,props, emit, getAssetUrl, popup, localValue, closePopup }
}

})